export interface Category {
  id: string;
  name: string;
  slug: string;
  description: string;
  icon: string;
  count: number;
  imageSeq: string;
}

export const categories: Category[] = [
  {
    id: 'dianying',
    name: '电影',
    slug: 'dianying',
    description: '海量高清电影资源，涵盖动作、喜剧、爱情、科幻、悬疑等多种类型，免费在线观看不缓冲。',
    icon: 'ri-movie-2-line',
    count: 2856,
    imageSeq: 'cat-dianying-01',
  },
  {
    id: 'dianshiju',
    name: '电视剧',
    slug: 'dianshiju',
    description: '热门电视剧全集在线播放，国产剧、港台剧、美剧、韩剧应有尽有，更新快画质高清。',
    icon: 'ri-tv-2-line',
    count: 3421,
    imageSeq: 'cat-dianshiju-01',
  },
  {
    id: 'zongyi',
    name: '综艺',
    slug: 'zongyi',
    description: '最新最热的综艺节目合集，真人秀、脱口秀、音乐竞技、旅行节目等精彩内容一网打尽。',
    icon: 'ri-emotion-laugh-line',
    count: 1567,
    imageSeq: 'cat-zongyi-01',
  },
  {
    id: 'dongman',
    name: '动漫',
    slug: 'dongman',
    description: '国内外精品动漫资源，日漫、国漫、美漫全收录，热门番剧同步更新，二次元爱好者的天堂。',
    icon: 'ri-rocket-2-line',
    count: 2234,
    imageSeq: 'cat-dongman-01',
  },
  {
    id: 'jilupian',
    name: '纪录片',
    slug: 'jilupian',
    description: 'BBC、Discovery、央视等高品质纪录片，涵盖自然、历史、科技、人文等各个领域。',
    icon: 'ri-earth-line',
    count: 892,
    imageSeq: 'cat-jilupian-01',
  },
  {
    id: 'shaoer',
    name: '少儿',
    slug: 'shaoer',
    description: '适合儿童观看的优质动画和教育节目，安全健康的观影内容，陪伴孩子快乐成长。',
    icon: 'ri-star-smile-line',
    count: 645,
    imageSeq: 'cat-shaoer-01',
  },
];